import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import FlowService from '../../services/flow-service';

// Flow 391 is the 'nhs' slug flow — stable across environments
const NHS_FLOW_ID = 391;

const CreateAccountPreFlow: React.FC = () => {
  const { search } = useLocation();

  useEffect(() => {
    // No origin rewrite here: the create-account flow (and its Auth0 callback + the mobile
    // handoff) stay on whichever origin they started on. buildCanonicalRedirectUri() uses the
    // current origin, which Auth0 already allows, so localStorage / the sl-user-flow cookie /
    // the sessionStorage redirect_url all remain visible across the round-trip.
    const params = new URLSearchParams(search);
    const redirectUrl = params.get('redirect_url') ?? '';

    // Pre-warm the Country Selector step for all users.
    // FlowService uses 'sl-flow-progress' — removeAnswers() (which clears 'sl-answers')
    // inside redirectUserToAppropriateFlow does not erase this pre-warm.
    //
    // ?create_account=1 tells flow.container to skip the wrongOnboardingPlatform redirect
    // (iOS shares the Safari cookie store — a stale login cookie can cause isLoading forever).
    // is_create_account_flow hides the Log In button in the header for this flow (SLEEPIO-5833).
    sessionStorage.setItem('is_create_account_flow', 'true');
    FlowService.setLocalProgress(NHS_FLOW_ID, 1, 0);
    const caQs = `?create_account=1${
      redirectUrl ? `&redirect_url=${encodeURIComponent(redirectUrl)}` : ''
    }`;
    window.location.replace(`/sleepio/nhs${caQs}`);
  }, [search]);

  return null;
};

export default CreateAccountPreFlow;
